import { render, staticRenderFns } from "./show_ajouterBlocNote.vue?vue&type=template&id=70fe94c6&scoped=true&"
import script from "./show_ajouterBlocNote.vue?vue&type=script&lang=js&"
export * from "./show_ajouterBlocNote.vue?vue&type=script&lang=js&"
import style0 from "./show_ajouterBlocNote.vue?vue&type=style&index=0&id=70fe94c6&lang=scss&scoped=true&"
import style1 from "./show_ajouterBlocNote.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe94c6",
  null
  
)

export default component.exports